import React from "react"
import axios from 'axios';
import { PersonResultTable } from './results/PersonResultTable.jsx';
import I18n from 'i18n-js';
import '../translations.js';
export class AccountSearchFormSmall extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      newForm: this.props.skipSearch,
      showTable: false,
      resultArray: []
    };
    this.searchExistingUsers = this.searchExistingUsers.bind(this);
    this.searchExistingCompanies = this.searchExistingCompanies.bind(this);
    this.updateResultTable = this.updateResultTable.bind(this);
    this.showNewForm = this.showNewForm.bind(this);
  }

  searchExistingUsers(e) {
    e.preventDefault();
    this.setState({ entity: "person" });
    axios.post('/api/v1/search/user_search', {
      first_name: this.first_name.value,
      last_name: this.last_name.value
      })
      .then(response => this.updateResultTable(response.data))
      .catch(error => this.setState({ errorMessage: 'Error...'}));
  }

  searchExistingCompanies(e) {
    e.preventDefault();
    this.setState({ entity: "company" });
    axios.post('/api/v1/search/company_search', { company_name: this.company_name.value })
      .then(response => this.updateResultTable(response.data))
      .catch(error => this.setState({ errorMessage: 'Error...'}));
  }


  updateResultTable(data) {
    this.setState({ 
      showTable: true,
      resultArray: data.users 
    });
  }

  showNewForm() {
    this.setState({ newForm: true });
  }

  render () {
    return (
      <div>
        <div className="search_form">
          <div className="span12">
            <input type="text" className="first_name_input" placeholder={I18n.t("first_name")} minLength="2" key="1" ref={input => this.first_name = input} />
            <span> </span>
            <input type="text" className="last_name_input" placeholder={I18n.t("last_name")} minLength="2" key="2" ref={input => this.last_name = input} />
            <span> </span>
            <button className="person-search-btn btn btn-info" onClick={this.searchExistingUsers}>{I18n.t("search")}</button>
            <p> {I18n.t("user.user_search_hint")}</p>
          </div>
          {this.props.company ?
            <div className="span12">
              <input type="text" placeholder={I18n.t("company_name")} minLength="2" key="3" ref={input => this.company_name = input} />
              <span> </span>
              <button className="btn btn-info" onClick={this.searchExistingCompanies}>{I18n.t("search")}</button>
              <p>{I18n.t("exhibitor.company_search_hint")}</p>
            </div>
            :
            undefined
          }
          <div>
            {this.state.showTable ? 
              <PersonResultTable 
                results={this.state.resultArray} 
                target={this.props.target} 
                addPerson={this.props.addPerson} 
                entity={this.state.entity} />
              : undefined
            }
          </div>
        </div>
      </div>
    );
  }
}

